import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2bf5af7c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "contact-books-table-container full-height" };
const _hoisted_2 = { class: "contact-books-table" };
const _hoisted_3 = { class: "contact-books-table-head" };
const _hoisted_4 = { class: "row head-row" };
const _hoisted_5 = { class: "header-cell name" };
const _hoisted_6 = { class: "header-cell date" };
const _hoisted_7 = { class: "header-cell contacts" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header-cell actions" }, null, -1));
const _hoisted_9 = { class: "contact-books-table-body" };
const _hoisted_10 = { class: "cell name" };
const _hoisted_11 = { class: "book-name" };
const _hoisted_12 = { class: "cell date" };
const _hoisted_13 = { class: "cell contacts" };
const _hoisted_14 = { class: "cell actions with-overflow" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_or_button = _resolveComponent("or-button");
    const _component_or_icon = _resolveComponent("or-icon");
    const _component_contact_books_status = _resolveComponent("contact-books-status");
    const _component_contact_book_overflow_menu = _resolveComponent("contact-book-overflow-menu");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_or_button, {
                            class: "order-button",
                            size: "small",
                            type: "text",
                            content: _ctx.$t('contactBooks.controls.order.name'),
                            icon: _ctx.order === _ctx.ContactBooksOrderModes.ASC ? 'arrow_downward' : 'arrow_upward',
                            "icon-position": "right",
                            color: "neutral-6",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('changeOrder')))
                        }, null, 8, ["content", "icon"])
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('contactBooks.table.dateModified')), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('contactBooks.table.contacts')), 1),
                    _hoisted_8
                ])
            ]),
            _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                        key: item.bookId,
                        class: "row",
                        to: {
                            name: 'contacts',
                            params: {
                                bookName: item.name
                            }
                        }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_or_icon, {
                                    icon: "contacts",
                                    color: "neutral-4"
                                }),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1),
                                _createVNode(_component_contact_books_status, {
                                    sharer: item.source.accountName,
                                    state: _ctx.getBookState(item)
                                }, null, 8, ["sharer", "state"])
                            ]),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$d(item.modified, 'short')), 1),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$tc('contactBooks.contact', item.count)), 1),
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_contact_book_overflow_menu, {
                                    onDelete: ($event) => (_ctx.$emit('delete', item.name)),
                                    onMigrate: ($event) => (_ctx.$emit('migrate', item.name)),
                                    onOpen: ($event) => (_ctx.$emit('open', item.name))
                                }, null, 8, ["onDelete", "onMigrate", "onOpen"])
                            ])
                        ]),
                        _: 2
                    }, 1032, ["to"]));
                }), 128))
            ])
        ])
    ]));
}
